import { DISTRIBUTIONS } from '../names';

import { change } from 'redux-form';

export const setAlpha = alpha =>
  change(DISTRIBUTIONS, 'alpha', alpha);

export const setLeftCutoff = leftCutoff =>
  change(DISTRIBUTIONS, 'leftCutoff', leftCutoff);

export const setRightCutoff = rightCutoff =>
  change(DISTRIBUTIONS, 'rightCutoff', rightCutoff);

export const setBLeftCutoff = leftCutoff =>
  change(DISTRIBUTIONS, 'bLeftCutoff', leftCutoff);

export const setBRightCutoff = rightCutoff =>
  change(DISTRIBUTIONS, 'bRightCutoff', rightCutoff);

export const setLeftZScore = ZScore =>
  change(DISTRIBUTIONS, 'leftZScore', ZScore);

export const setRightZScore = ZScore =>
  change(DISTRIBUTIONS, 'rightZScore', ZScore);
